import React, { useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import LandingPage from "src/components/pages/landing/landingPage";
import TemplatesPage from "src/components/pages/templates/templatesPage";
import { useAppDispatch, useAppSelector } from "src/store/store";
import { getAllInspectionTemplates } from "src/store/inspectionTemplateSlice";
import { getInspectionsByUser } from "src/store/inspectionSlice";
import QuestionsPage from "./pages/questions/questionsPage";
import InspectionPage from "./pages/inspection/inspectionPage";
import AdminLayout from "./pages/admin/adminLayout";
import RequireAdmin from "./pages/admin/requireAdmin";
import CompletedInspections from "./pages/inspection/completedInspections";
import InspectionRouter from "./pages/inspection/inspectionRouter";
import BarcodeScannerPage from "./pages/barcodeScanner/BarcodeScannerPage";

const AuthorizedContent = () => {
  const dispatch = useAppDispatch();
  const { scannedBarcode } = useAppSelector((state) => state.inspectionCapture);
  
  useEffect(() => {
    dispatch(getAllInspectionTemplates());
    dispatch(getInspectionsByUser());
  }, []);
  
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/home" />} />
      <Route path="/home" element={<LandingPage />} />
      <Route
        path="/admin/*"
        element={
          <RequireAdmin>
            <AdminLayout />
          </RequireAdmin>
        }
      />
      <Route path="/templates" element={<TemplatesPage />} />
      <Route path="/templates/:templateId" element={<QuestionsPage />} />
      <Route
        path="/templates/:templateId/barcode-scan"
        element={<BarcodeScannerPage />}
      />
      <Route
        path="/templates/:templateId/inspection"
        element={<InspectionPage key={scannedBarcode || 'default'} />}
      />
      <Route path="/completedInspections" element={<CompletedInspections />} />
      <Route path="/inspections/:inspectionId" element={<InspectionRouter />} />
    </Routes>
  );
};

export default AuthorizedContent;

